<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сторисы</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <StoriesTabLinks />
                        <StoriesTable
                            class="mt-4"
                            :data.sync="data"
                            @select="(id) => $router.push(`stories/${id}`)"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`stories/create`)"
                    >Создать</CButton
                    >
                    <CButton
                        class="ml-4"
                        color="info"
                        @click="reorder"
                    >Сохранить расположение</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import StoriesTable from '@/components/stories/StoriesTable';
    import StoriesTabLinks from '@/components/StoriesTabLinks';

    export default {
        name: 'StoriesList',

        components: {
            StoriesTable,
            StoriesTabLinks
        },

        data() {
            return {
                loading: true,
                data: [],
            };
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const response = await this.axios.get('/stories');
                this.data = response.data;

            },
            async reorder() {
                try {
                    const payload = {
                        reorder: this.data.map((item, idx) => ({ id: item.id, position: idx + 1, title: item.title }))
                    };
                    await this.axios.post('/stories/update/reorder', payload)
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка сохранения порядка.');
                }
            }
        },
    };
</script>
